import { Pipe, PipeTransform } from "@angular/core";
import { BillingService } from "../services/billing.service";
import { BILLING_TYPE } from "@comunicare/comunicare-interfaces";

@Pipe({
  name: "availableStatusTransitions",
})
export class AvailableStatusTransitionsPipe implements PipeTransform {
  constructor(public billingService: BillingService) {}

  transform(value: BILLING_TYPE): BILLING_TYPE[] {
    return this.billingService.getAvailableStatusTransitions(value);
  }
}
